import PageTabs from "PFComponents/page/page_tabs";
import React, { JSX } from "react";

import css from "./export_wizard_content.module.scss";
import { useExportWizardTabs } from "./use_export_wizard_tabs";

export const ExportWizardContent = (): JSX.Element => {
  const { currentTab, tabs, handleClickTab, TabComponent } = useExportWizardTabs();

  return (
    <div className={css.exportWizardContent}>
      <PageTabs
        rootClassName={css.tabs}
        items={tabs}
        active={currentTab}
        handleClick={handleClickTab}
        capitalize={false}
      />
      <TabComponent />
    </div>
  );
};
